import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metric-max",
  "use": "icon-metric-max-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-metric-max\"><path d=\"M11.4 7.1 8 3.8 4.6 7.1l.8.8 2.1-2.2V12h1V5.7l2.1 2.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol